import { Constant } from "../../config";
import axios from "axios";
import MyModal from "../Modal";
import { notification } from "antd";

export default {
  _getCountryList: async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    let rtn = [{ region_code: "NONE", name: "Default" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  },
  _getGatewayList: async () => {
    const opt = {
      url: `${Constant.GATEWAY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    return resp.data.data;
  },
  _getRevisionList: async () => {
    const opt = {
      url: `${Constant.REVISION_PRICE_API}?page=1&limit=-1`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    return resp.data.data;
  },
  reGenerate: (id) => {
    MyModal.confirm(
      "คุณต้องการส่งอีเมลถึงผู้ใช้งานอีกครั้ง ใช่หรือไม่ ?",
      "",
      async (f) => {
        if (!f) return;

        let opt = {
          url: Constant.MEMBER_INVITE_AGAIN_API.replace("[id]", id),
          method: "GET",
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem(Constant.SessionKey),
          },
        };
        let resp;
        let eMsg = `เกิดข้อผิดพลาด ไม่สามารถส่งอีเมลถึงผู้ใช้งานได้ กรุณาลองใหม่อีกครั้ง`;
        let eMsgDetail = "";
        let eFlag = false;

        try {
          resp = await axios(opt);
        } catch (err) {
          resp = err.response;
        }

        if (!resp.data) {
          eFlag = true;
        } else if (resp.data.error) {
          eFlag = true;
          let e = resp.data.error;
          eMsgDetail = `[${e.code}] ${e.name}`;
        }

        if (eFlag) {
          MyModal.error(eMsg, eMsgDetail, () => {
            window.location.reload();
          });
        } else {
          MyModal.info("ส่งอีเมลถึงผู้ใช้งานสำเร็จ");
        }
      },
      "ใช่",
      "ไม่ใช่"
    );
  },
  getAdminLists: async () => {
    let url = Constant.ADMIN_GETALL_API;

    let opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    return resp.data.data || [];
  },
  handlerError: (resp) => {
    let result = false;
    if (resp.error) {
      notification.error({
        message: resp.error.name,
        description: resp.error.description,
      });
    } else {
      result = true;
      notification.success({
        message: "การเพิ่มข้อมูลเสร็จสิ้น",
      });
    }

    return result;
  },
};



// WEBPACK FOOTER //
// ./src/containers/User/services.js